import React from 'react'
import { TerminalWindow, TerminalLine } from '@/components/frontend/atoms/content/Terminal'
import { useTranslation } from '@/hooks/useTranslation'

const PROFILE_FIELDS = ['name', 'role', 'helps', 'builds', 'based', 'status'] as const

export const ProfileTerminal: React.FC = () => {
  const { t } = useTranslation()

  return (
    <TerminalWindow title={t('profile.title')}>
      <TerminalLine kind="command">{t('profile.command')}</TerminalLine>
      {PROFILE_FIELDS.map((field) => (
        <TerminalLine key={field} kind="field" label={t(`profile.${field}_label`)}>
          {t(`profile.${field}_value`)}
        </TerminalLine>
      ))}
      <TerminalLine kind="comment">{t('profile.comment')}</TerminalLine>
    </TerminalWindow>
  )
}
